<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!-- begin: Single Modal -->
    <router-view />
    <!-- end: Single Modal -->

    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ประเภทการเคลม:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control'"
                  :id="'abcClaimTypeCode'"
                  :name="'abcClaimTypeCode'"
                  :select2-options="abcClaimTypeCodeOptions"
                  v-model="abcClaimTypeCode"
                  ref="abcClaimTypeCodeSelect2"
                  @selectChange="onClaimTypeCodeChange"
                  disabled
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div
                class="form-group"
                v-show="abcClaimTypeCode == 'BEER_CLAIM_TYPE_AGENT'"
              >
                <label class="label-required">ตัวแทนจำหน่าย:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control m-select2'"
                  :id="'abcAgentCode'"
                  :name="'abcAgentCode'"
                  :select2-options="abcAgentCodeOptions"
                  v-model="abcAgentCode"
                  ref="abcAgentCodeSelect2"
                  @selectChange="onAgentCodeChange"
                ></select2>
                <span class="form-text"></span>
              </div>

              <div
                class="form-group"
                v-show="abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'"
              >
                <label class="label-required">ร้านค้า:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control m-select2'"
                  :id="'abcShopCode'"
                  :name="'abcShopCode'"
                  :select2-options="abcShopCodeOptions"
                  v-model="abcShopCode"
                  ref="abcShopCodeSelect2"
                  @selectChange="onShopCodeChange"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">อำเภอ:</label>
                <input
                  id="abcAmpher"
                  name="abcAmpher"
                  v-model="abcAmpher"
                  type="text"
                  maxlength="450"
                  class="form-control"
                  placeholder="อำเภอ"
                  disabled
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">จังหวัด:</label>
                <input
                  id="abcProvince"
                  name="abcProvince"
                  v-model="abcProvince"
                  type="text"
                  maxlength="450"
                  class="form-control"
                  placeholder="จังหวัด"
                  disabled
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">เบอร์โทร:</label>
                <input
                  id="abcPhone"
                  name="abcPhone"
                  v-model="abcPhone"
                  type="text"
                  maxlength="450"
                  class="form-control"
                  placeholder="เบอร์โทร"
                  disabled
                />
              </div>
            </div>
          </div>

          <div
            class="kt-section kt-section--first"
            v-show="
              abcClaimTypeCode != null &&
                (abcAgentCode != null || abcShopCode != null)
            "
          >
            <h3 class="kt-section__title">รายการสินค้าเคลม:</h3>
            <div class="kt-section__body">
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table
                    class="table table-sm table-striped table-bordered table-hover table-checkable"
                  >
                    <thead>
                      <tr>
                        <th class="text-center" width="5%">ลำดับ</th>
                        <th class="text-center" width="15%">แบรนด์สินค้า</th>
                        <th class="text-center" width="15%">ชื่อสินค้า</th>
                        <th class="text-center" width="10%">BARCODE</th>
                        <th class="text-center" width="10%">รหัสทรัพย์สิน(เบียร์สด)</th>
                        <th class="text-center" width="15%">ปัญหาที่พบ</th>
                        <th class="text-center" width="5%">คำสั่ง</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-if="
                          abcClaimItems == null || abcClaimItems.length == 0
                        "
                      >
                        <td colspan="9" class="text-muted text-center">
                          คลิก + เพื่อเพิ่มรายการใหม่
                        </td>
                      </tr>
                      <template v-for="(item, i) in abcClaimItems">
                        <tr>
                          <td class="text-center">{{ i + 1 }}</td>
                          <td class="text-center">{{ item.productBrand }}</td>
                          <td class="text-center">{{ item.material }}</td>
                          <td class="text-center">{{ item.barcodeOld }}</td>
                          <td class="text-center">{{ item.depCode }}</td>
                          <td class="text-center">{{ item.problemType }}</td>
                          <td>
                            <center>
                              <button
                                v-show="
                                  !item.claimItemId ||
                                    (!!item.claimItemId && item.claimStatusCode == 'CLAIM_STATUS_SUBMIT') ||
                                    (!!item.claimItemId && item.isBeerClaimAdmin)
                                "
                                type="button"
                                class="btn btn-outline-hover-warning btn-elevate btn-circle btn-icon"
                                @click.prevent="onEditItemClick(i)"
                              >
                                <i class="text-warning la la-edit"></i>
                              </button>
                              <button
                                v-show="
                                  !item.claimItemId ||
                                    (!!item.claimItemId &&
                                      item.claimStatusCode ==
                                        'CLAIM_STATUS_SUBMIT')
                                "
                                type="button"
                                class="btn btn-outline-hover-danger btn-elevate btn-circle btn-icon"
                                @click.prevent="onRemoveItemClick(i)"
                              >
                                <i class="text-danger la la-trash"></i>
                              </button>
                            </center>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                    <tfoot
                      v-if="abcClaimItems == null || abcClaimItems.length == 0"
                    >
                      <tr>
                        <td colspan="9">
                          <router-link
                            :to="
                              this.$route.params.id + '/AddItem/add_' + index
                            "
                            tag="button"
                            title="เพิ่ม Claim Item"
                            class="btn btn-outline-brand"
                            v-if="
                              this.$root.canShow([
                                'ADMIN_BEER_CLAIM',
                                'AGENT_ADMIN_BEER_CLAIM',
                              ])
                            "
                          >
                            <i class="fa fa-plus"></i> เพิ่ม Claim Item
                          </router-link>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="kt-portlet__foot">
        <button type="button" class="btn btn-secondary" @click="$router.go(-1)">
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button type="submit" class="btn btn-primary">
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../Shared/Select2";
import datepicker from "../../Shared/Datepicker";

export default {
  components: {
    select2,
    datepicker,
  },
  data: function() {
    var self = this;

    return {
      isBeerClaimAdmin: false,
      isEdit: false,
      abcClaimTypeCode: null,
      abcAgentCode: null,
      abcShopCode: null,
      abcAmpher: null,
      abcProvince: null,
      abcPhone: null,
      abcClaimItems: [],
      index: 0,
      abcAgentCodeTmp: null,

      // Configurations
      abcClaimTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "BEER_CLAIM_TYPE",
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      abcAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2AgentData",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      abcShopCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopData",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    async uploadFile(file) {
      const formData = new FormData();
      formData.append('File', file);
      formData.append('FolderName', 'BeerClaim');
      try {
        const response = await axios.post('/Api/File/FileUpload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        return response.data;
      } catch (error) {
        // console.error("Error uploading file:", error);
        throw error;
      }
    },
    async formSubmit(e) {
      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      if (this.abcClaimItems == null || this.abcClaimItems.length == 0)
        return false;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      let router = this.$router;
      let self = this;

      var cItems = [];
      for (let element of self.abcClaimItems) {
        if (
          !element.claimStatusCode ||
          element.claimStatusCode == "CLAIM_STATUS_SUBMIT" ||
          self.isBeerClaimAdmin
        ) {
          if (element.uploadFiles === undefined) {
            element.uploadFiles = element.Pictures;
          }
          let uploadedFiles = [];
          if (element.uploadFiles) {
            for (let file of element.uploadFiles) {
              if(file && file.fileDataContext){
                const uploadResponse = await self.uploadFile(file.fileDataContext);
                uploadedFiles.push({
                  contentType: file.fileDataContext.type,
                  downloadUrl: uploadResponse.fileUrl,
                  fileInfoId: uploadResponse.fileInfoId,
                  fileName: file.fileDataContext.name,
                  gridFsId: uploadResponse.gridFsId,
                  sysName: '-',
                });
              }else if(file && file.claimItemPictureId){
                uploadedFiles.push({
                  claimItemPictureId: file.claimItemPictureId,
                  fileInfoId: file.fileInfoId,
                })
              }
            }
          }
          if(element.machineCategory === 'true'){
            element.machineCategory = true;
          }
          if(element.machineCategory === 'false'){
            element.machineCategory = false;
          }
          cItems.push({
            ProductBrandId: element.productBrandId,
            MaterialCode: element.materialCode,
            Barcode: element.barcode,
            ManufacturingDate: element.manufacturingDate
              ? element.manufacturingDate.format("DD/MM/YYYY")
              : null,
            Weight: element.weight,
            ProblemTypeCode: element.problemTypeCode,
            ProblemDesc: element.problemDesc,
            MachineTypeCode: element.machineTypeCode,
            MachineBarcode: element.machineBarcode,
            MachineCategory: element.machineCategory,
            Pressure: element.pressure,
            Temperature: element.temperature,
            PMDate: element.pmDate ? element.pmDate.format("DD/MM/YYYY") : null,
            JumpDate: element.jumpDate
              ? element.jumpDate.format("DD/MM/YYYY")
              : null,
            StandardInstallCode: element.standardInstallCode,
            AgentReceivedDate: element.agentReceivedDate.format("DD/MM/YYYY"),
            ShopReceivedDate: element.shopReceivedDate
              ? element.shopReceivedDate.format("DD/MM/YYYY")
              : null,
            Invoice: element.invoice,
            Pictures: uploadedFiles,
          });
        }
      }

      axios
        .put("/Api/BeerClaim", {
          BeerClaimItems: cItems,
          ClaimId: this.$route.params.id,
          ClaimTypeCode: this.abcClaimTypeCode,
          ClaimAgentCode:
            this.abcClaimTypeCode == "BEER_CLAIM_TYPE_AGENT"
              ? this.abcAgentCode
              : null,
          ClaimShopCode:
            this.abcClaimTypeCode == "BEER_CLAIM_TYPE_SHOP"
              ? this.abcShopCode
              : null,
        })
        .then(function(response) {
          if (response.data.status) {
            KTApp.unblockPage();
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            //console.log(response);
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    onAgentCodeChange: function(id, text, data, ref) {
      var self = this;
      //console.log("data agent ", data);
      if (data[0].data) {
        self.abcAmpher = data[0].data.ampherName;
        self.abcProvince = data[0].data.provinceName;
        self.abcPhone = data[0].data.phone;
        self.abcAgentCodeTmp = self.abcAgentCode;
      }
    },
    onShopCodeChange: function(id, text, data, ref) {
      var self = this;
      //console.log("data shop ", data);
      if (data[0].data) {
        self.abcAmpher = data[0].data.ampherName;
        self.abcProvince = data[0].data.provinceName;
        self.abcPhone = data[0].data.phone;
        self.abcAgentCodeTmp = data[0].data.agentCode;
      }
    },
    onClaimTypeCodeChange() {
      var self = this;
      self.abcAmpher = null;
      self.abcProvince = null;
      self.abcPhone = null;
      self.abcAgentCode = null;
      self.abcShopCode = null;
      self.abcClaimItems = [];
    },
    onRemoveItemClick(index) {
      this.abcClaimItems.splice(index, 1);
    },
    onEditItemClick(index) {
      let router = this.$router;
      var item = this.abcClaimItems[index];
      //console.log("list " ,this.abcClaimItems[index]);
      router.push({
        path:
          "/BeerClaim/Claim/Edit/" +
          this.$route.params.id +
          "/EditItem/" +
          index,
      });
    },
    handleBackButton(event) {
      const modalBackdrops = document.querySelectorAll('.modal-backdrop');
      modalBackdrops.forEach(modalBackdrop => {
        modalBackdrop.remove();
      });
    }
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();
    window.addEventListener('popstate', this.handleBackButton);

    if(this.$root.canShow(['super_admin']) == true){
      self.isBeerClaimAdmin = true;
    }else{
      if(typeof this.$root.user.profile.role == "object"){
        const resultAdmin = this.$root.user.profile.role.filter(word => word == "ADMIN_BEER_CLAIM");
        if(resultAdmin.length > 0){
          self.isBeerClaimAdmin = true;
        }else{
          self.isBeerClaimAdmin = false;
        }
      }else if(typeof this.$root.user.profile.role == "string"){
        if(this.$root.user.profile.role == "ADMIN_BEER_CLAIM"){
          self.isBeerClaimAdmin = true;
        }else{
          self.isBeerClaimAdmin = false;
        }
      }else{
        self.isBeerClaimAdmin = false;
      }
    }
    let paramsID = this.$route.params.id;
    if(this.$route.params.id == 0){
      let parts = this.$route.path.split('/');
      paramsID = parts[4];
      router.go(-1);
    }
    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
    });
    axios
      .get("/Api/BeerClaim/" + paramsID)
      .then(function(response) {
        //console.log(response);
        if (response.status == 200) {
          setTimeout(function() {
            if (response.data.claimTypeCode) {
              self.$refs.abcClaimTypeCodeSelect2.setSelectedData({
                id: response.data.claimTypeCode,
                text: response.data.claimTypeName,
              });
            }
          }, 100);

          setTimeout(function() {
            if (response.data.claimAgentCode) {
              self.$refs.abcAgentCodeSelect2.setSelectedData({
                id: response.data.claimAgentCode,
                text: response.data.claimAgentName,
              });
            }
            self.abcAmpher = response.data.ampherName;
            self.abcProvince = response.data.provinceName;
            self.abcPhone = response.data.tel;
            self.abcAgentCodeTmp = response.data.claimAgentCode;
          }, 100);

          setTimeout(function() {
            if (response.data.claimShopCode) {
              self.$refs.abcShopCodeSelect2.setSelectedData({
                id: response.data.claimShopCode,
                text: response.data.claimShopName,
              });
            }
            self.abcAmpher = response.data.ampherName;
            self.abcProvince = response.data.provinceName;
            self.abcPhone = response.data.tel;
          }, 100);

          //#region :: set beerClaimItems
          setTimeout(function() {
            if (response.data.beerClaimItems) {
              response.data.beerClaimItems.forEach((b) => {
                self.abcClaimItems.push({
                  isBeerClaimAdmin: self.isBeerClaimAdmin,
                  productBrandId: b.productBrandId,
                  productBrand: b.productBrandName,
                  materialCode: b.materialCode,
                  material: b.materialName,
                  barcode: b.barcodeNumber,
                  depCode: b.departmentMaterialCode,
                  macDepcode: b.machineDepartmentMaterialCode,
                  barcodeOld: b.barcodeNumberOld,
                  manufacturingDate: b.manufacturingDateFormat
                    ? moment(b.manufacturingDateFormat, "DD/MM/YYYY")
                    : null,
                  weight: b.weight,
                  problemTypeCode: b.problemTypeCode,
                  problemType: b.problemTypeName,
                  problemDesc: b.problemDesc,
                  machineTypeCode: b.machineTypeCode,
                  machineType: b.machineTypeName,
                  machineBarcode: b.machineBarcodeNumber,
                  machineBarcodeOld: b.machineBarcodeNumberOld,
                  machineCategory: b.machineCategory,
                  pressure: b.pressure,
                  temperature: b.temperature,
                  pmDate: b.pmDateFormat
                    ? moment(b.pmDateFormat, "DD/MM/YYYY")
                    : null,
                  jumpDate: b.jumpDateFormat
                    ? moment(b.jumpDateFormat, "DD/MM/YYYY")
                    : null,
                  standardInstallCode: b.standardInstallCode,
                  standardInstall: b.standardInstallName,
                  claimStatusCode: b.claimStatusCode,
                  claimItemId: b.claimItemId,
                  agentReceivedDate: b.agentReceivedDateFormat
                    ? moment(b.agentReceivedDateFormat, "DD/MM/YYYY")
                    : null,
                  shopReceivedDate: b.shopReceivedDateFormat
                    ? moment(b.shopReceivedDateFormat, "DD/MM/YYYY")
                    : null,
                  invoice: b.invoice,
                  claimItemPicture: b.claimItemPicture,
                  Pictures: b.claimItemPicture,
                });
                self.index += 1;
              });
              //console.log("list edit ", self.abcClaimItems);
            }
          }, 100);
          //#endregion :: set beerClaimItems
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูลเบียร์เคลมที่คุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลเบียร์เคลมได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });

    // set validation rules
    $(this.$refs.form).validate({
      rules: {
        abcClaimTypeCode: "required",
        abcAgentCode: "required",
        abcShopCode: "required",
      },
      messages: {
        abcClaimTypeCode: "กรุณาเลือกประเภทการเคลม",
        abcAgentCode: "กรุณาเลือกตัวแทนจำหน่าย",
        abcShopCode: "กรุณาเลือกร้านค้า",
      },
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/BeerClaim/EditBeerClaim.vue